import { render, staticRenderFns } from "./bsp-tabs-v2.vue?vue&type=template&id=8edb0270&scoped=true&"
import script from "./bsp-tabs-v2.vue?vue&type=script&lang=js&"
export * from "./bsp-tabs-v2.vue?vue&type=script&lang=js&"
import style0 from "./bsp-tabs-v2.vue?vue&type=style&index=0&id=8edb0270&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8edb0270",
  null
  
)

export default component.exports